import {
  Building2,
  Globe2,
  MessageSquare,
  Target,
  Car,
  TreePalm,
  Sun,
  Waves,
} from "lucide-react";

export const companyInfo = {
  name: "Beit Nour Group",
  tagline: "House of Light",
  subtitle: "Illuminating Industries Across Continents",
  description:
    "Beit Nour Group is a diversified holding company with strategic investments spanning luxury real estate, technology innovation, customer experience consulting, and sustainable mobility. With operations across the Middle East, Europe, Southeast Asia, and Africa, we build enterprises that shape tomorrow.",
  founded: "2020",
  headquarters: "Dubai, UAE",
  founderName: "Yitayal Menkir",
  founderTitle: "Founder & Chairman",
  founderBio:
    "A visionary entrepreneur with a passion for building businesses that create lasting impact across diverse industries and continents. From luxury real estate in Dubai and Bali to AI-powered technology for Africa, Yitayal leads Beit Nour Group with a relentless drive to illuminate new possibilities.",
  founderImage:
    "https://customer-assets.emergentagent.com/job_saqer-portfolio/artifacts/l2pusm93_picture%20_1271x1364.jpg",
  mission:
    "To build and nurture a portfolio of world-class enterprises that drive innovation, create value, and illuminate new possibilities across every market we enter.",
  vision:
    "To be a globally recognized holding group known for excellence, integrity, and transformative impact across industries and continents.",
};

export const subsidiaries = [
  {
    id: 1,
    name: "Sofia Sands Bali",
    sector: "Luxury Real Estate",
    location: "Bali, Indonesia",
    description:
      "Premium luxury villas and investment properties in Bali's most sought-after locations. AI-powered ROI forecasting and curated investment opportunities in Seminyak, Canggu, and Uluwatu.",
    url: "https://sofiasandbali.com",
    iconName: "TreePalm",
    image: "https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?w=800&q=80",
    color: "#2D8B6F",
  },
  {
    id: 2,
    name: "Sofia Sands Realty",
    sector: "Premium Real Estate",
    location: "Dubai & RAK, UAE",
    description:
      "Expert guidance in Dubai and Ras Al Khaimah real estate. Exclusive listings, off-plan investments, and comprehensive property management with crypto payment options.",
    url: "https://www.sofiasandsrealty.ae",
    iconName: "Building2",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80",
    color: "#C9A84C",
  },
  {
    id: 3,
    name: "Helvetia Sands",
    sector: "Swiss Investment Gateway",
    location: "Switzerland",
    description:
      "Gateway to Dubai's finest real estate for Swiss investors. Premium services including private viewings, full legal briefing, and VIP concierge with 10+ years of market expertise.",
    url: "https://www.helvetiasands.ch/en",
    iconName: "Globe2",
    image: "https://images.unsplash.com/photo-1526642591341-bcfc36ffae2f?w=800&q=80",
    color: "#D44A3A",
  },
  {
    id: 4,
    name: "WakilChat",
    sector: "AI & Technology",
    location: "Africa",
    description:
      "AI-powered communication platform built for Africa's 1.4 billion people. Real-time translation across 50+ African languages, smart business tools, and mobile money integration.",
    url: "https://wakilchat.com",
    iconName: "MessageSquare",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80",
    color: "#4A90D9",
  },
  {
    id: 5,
    name: "The CX Lens",
    sector: "CX Consultancy",
    location: "GCC Region",
    description:
      "Specialist customer experience consultancy transforming how organizations deliver CX. Journey mapping, service operations, quality systems, and embedded partnership with 50+ transformations.",
    url: "https://thecxlens.org/",
    iconName: "Target",
    image: "https://images.unsplash.com/photo-1505624198937-c704aff72608?w=800&q=80",
    color: "#7B61A6",
  },
  {
    id: 6,
    name: "Saqer Moon Trading",
    sector: "Electric Vehicles",
    location: "UAE & Beyond",
    description:
      "Pioneering the future of sustainable mobility through strategic import and distribution of premium electric vehicles across the Middle East and emerging markets.",
    url: null,
    iconName: "Car",
    image: "https://images.unsplash.com/photo-1617886322009-e02db73a70ee?w=800&q=80",
    color: "#3AAFB9",
    comingSoon: true,
  },
  {
    id: 7,
    name: "Beit Nour Ibiza",
    sector: "Luxury Hospitality",
    location: "Ibiza, Spain",
    description:
      "Bringing the signature Beit Nour luxury experience to the Mediterranean. Premium hospitality and lifestyle ventures on one of Europe's most iconic islands.",
    url: null,
    iconName: "Sun",
    image: "https://images.unsplash.com/photo-1539635278303-d4002c07eae3?w=800&q=80",
    color: "#E8963E",
    comingSoon: true,
  },
  {
    id: 8,
    name: "Beit Nour Zanzibar",
    sector: "Luxury Hospitality",
    location: "Zanzibar, Tanzania",
    description:
      "Expanding our footprint into East Africa with luxury hospitality and real estate ventures on the pristine shores of Zanzibar. Part of our strategic vision for Africa.",
    url: null,
    iconName: "Waves",
    image: "https://images.unsplash.com/photo-1590523741831-ab7e8b8f9c7f?w=800&q=80",
    color: "#2D8B9F",
    comingSoon: true,
  },
];

export const stats = [
  { value: "8", label: "Portfolio Ventures" },
  { value: "6+", label: "Countries" },
  { value: "5", label: "Industries" },
  { value: "3", label: "Continents" },
];

export const industries = [
  "Real Estate",
  "Technology",
  "Consulting",
  "Automotive",
  "Hospitality",
];

export const locations = [
  { city: "Dubai", country: "UAE", type: "Headquarters" },
  { city: "Bali", country: "Indonesia", type: "Operations" },
  { city: "Zurich", country: "Switzerland", type: "Operations" },
  { city: "Ras Al Khaimah", country: "UAE", type: "Operations" },
  { city: "Ibiza", country: "Spain", type: "Expansion" },
  { city: "Zanzibar", country: "Tanzania", type: "Expansion" },
  { city: "Nairobi", country: "Kenya", type: "Development" },
  { city: "Addis Ababa", country: "Ethiopia", type: "Development" },
];

export const values = [
  {
    title: "Excellence",
    description:
      "We pursue the highest standards in everything we do, from luxury real estate to cutting-edge technology.",
  },
  {
    title: "Innovation",
    description:
      "We embrace AI, data-driven insights, and forward-thinking strategies to stay ahead of the curve.",
  },
  {
    title: "Integrity",
    description:
      "Built on trust and transparency, our relationships with clients and partners are our greatest asset.",
  },
  {
    title: "Impact",
    description:
      "Every venture we undertake aims to create meaningful, lasting change for communities and industries.",
  },
];

export const contactInfo = {
  email: "info@thecxlens.org",
};
